import { moneyRound } from '../../utils/format'
import { LoanQueryResult } from '../../components/queries/LoanQuery'

type Loan = Exclude<LoanQueryResult['loan'], null>

export const calculatePayedInterest = (loan: Loan) =>
  moneyRound(
    Math.max(
      0,
      loan.transactions
        .filter(tr => tr.__typename === 'PaymentTransaction')
        .reduce((sum, tr) => sum + (tr.amount || 0), 0) -
        (loan.state.loanedAmount || 0)
    )
  )

export default calculatePayedInterest



// WEBPACK FOOTER //
// ./src/utils/transactions/calculatePayedInterest.tsx